export default __webpack_public_path__ + "assets/work_experience_badge-a8580ad5bfa4955ff3cae1f7fc63cc22.png";